import { t } from "i18next";

export const nutritionEditorInitialValues = {};

export const mealOptions = [
  { id: 1, name: t("contexts.shared.select_an_option") },
  { id: 1, name: t("contexts.nutrition.breakfast") },
  { id: 2, name: t("contexts.nutrition.lunch") },
  { id: 4, name: t("contexts.nutrition.meal") },
  { id: 3, name: t("contexts.nutrition.snack") },
  { id: 5, name: t("contexts.nutrition.dinner") },
  { id: 6, name: t("contexts.nutrition.redinner") },
];

export const searchableOptions = [
  {
    id: 1,
    key: 1,
    name: t("contexts.nutrition.show_plan_on_list"),
    text: t("contexts.nutrition.show_plan_on_list"),
    value: 1,
  },
  {
    id: 0,
    key: 0,
    name: t("contexts.nutrition.do_not_show_plan_on_list"),
    text: t("contexts.nutrition.do_not_show_plan_on_list"),
    value: 0,
  },
];

export const activeOptions = [
  {
    id: 1,
    key: 1,
    name: 'Activar ahora',
    text: 'Activar ahora',
    value: 1,
  },
  {
    id: 0,
    key: 0,
    name: 'Asignar planeado',
    text: 'Asignar planeado',
    value: 0,
  },
]

export const skipOptions = [
   {
    id: 1,
    key: 1,
    name: 'Activar plan planeado',
    text: 'Activar plan planeado',
    value: 1,
  },
  {
    id: 0,
    key: 0,
    name: 'Dejar planeado',
    text: 'Dejar planeado',
    value: 0,
  },
]

export enum EditorType {
  Wizard = 'wizard',
  Active = 'active',
  Planned = 'planned',
  Scratch = 'scratch',
  Edit = 'edit',
  Duplicate = 'duplicate',
}